import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './flyoutMenu.module.css';
import Forward from '../../resources/images/Forward.svg';
import CloseIcon from '../../resources/images/Close.svg';

/* 
FlyoutMenu with static content , this uses i18n useTranslation hook to translate the content.
*/

export default function FlyoutMenu(props) {
  const { t } = useTranslation();

  function handleFlyout() {
    props.onClick(false);
  }

  return (
    <div data-testid="flyoutContainer" className={styles.callout}>
      <div className={styles.headerContainer}>
        <p className={styles.flyoutHeader}>{t('flyoutHeaderText')}</p>
        <img
          onClick={handleFlyout}
          className={styles.closeIcon}
          src={CloseIcon}
          alt={t('altTextCloseIcon')}
        />
      </div>

      <p className={styles.flyouttext}>{t('flyoutmenutext')}</p>
      <a
        data-testid="flyoutlink"
        href="https://myworkaccount.microsoft.com/"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.accountLink}
      >
        {t('flyoutLinkText')}
      </a>
      <img className={styles.linkIcon} src={Forward} alt={t('altTextlinkto')} />
    </div>
  );
}
